import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=105400d6&scoped=true&"
import script from "./PerPage.vue?vue&type=script&lang=js&"
export * from "./PerPage.vue?vue&type=script&lang=js&"
import style0 from "./PerPage.vue?vue&type=style&index=0&id=105400d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105400d6",
  null
  
)

export default component.exports